class TextBlock implements ng.IComponentController {
    ltTitle: string;
    description: string;
    text: string;
    buttons: anm.LandingButtonData[];
    color: string;
    size: string;

    constructor() {
        this.color = this.color || 'white';
        this.size = this.size || 'large';
    }
}

angular.module('animatronApp.textBlock', []).component('textBlock', {
    bindings: {
        ltTitle: '<?',
        color: '@?',
        size: '@?',
        description: '<?',
        text: '<?',
        buttons: '<?',
    },
    controller: TextBlock,
    templateUrl: require('landing-template/components/text-block.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/landing-template/components/TextBlock.ts